<template>
	<el-dialog
		:visible.sync="isShow"
    custom-class='update_dialog'
    width="800px"
    :show-close="false"
	>
		<div class="update_dialog__body">
      <img src="/static/img/sys/ud_close.png" alt="" class="body_close" @click="close">
      <div class="jumpBtn" @click = "jumpPage">
        <span>去查看</span>
        <i class="el-icon-right"></i>
      </div>
    </div>
	</el-dialog>
</template>
<script>
	export default {
		props: {
			showVisibles: Boolean,
      updateInfo: Object
		},
		components: {

		},
		data() {
			return {


			}
		},
		created() {
		},
		computed: {
      // 显示弹窗
			isShow: {
				get () {
					return this.showVisibles;
				},
				set (val) {
					this.$emit('update:showVisibles', val);
				}
			},
		},
		methods: {
      close() {
        let uid=JSON.parse(sessionStorage.getItem('user')).accountId
        this.$http.post('msg/notify/closeMsg', {noticeId:this.updateInfo.id,userId:uid},{form:'houtai'}).then(res=>{
          if(res && res.data.code == 200) {
              this.dialogVisible=false
              this.$emit('sysclose')
          }
        })
        this.isShow = false
      },
      jumpPage() {
        if(this.$route.path == this.updateInfo.path) {
          this.$message.warning('您就在当前新页面！')
        }else {
          this.$router.push({ path: this.updateInfo.path})
        }
        this.close()
      }
		},
		watch: {

		}
	}
</script>
<style lang='less'>
.update_dialog {
  background: url("/static/img/sys/ud_body.png") no-repeat;
  background-size: 100% 100%;
  height: 560px;
  box-shadow: none;
 .update_dialog__body {
    position: relative;
    height: 500px;
    padding: 0;
    .body_bg {
      width: 100%;
    }
    .body_close {
      position: absolute;
      top: -50px;
      right: -50px;
      cursor: pointer;
    }
    .jumpBtn {
      padding: 10px 28px;
      flex-shrink: 0;
      border-radius: 10px;
      background: #269D7B;
      position: absolute;
      bottom: 30px;
      right: 155px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/updateDialog.vue